import type { JSX, ReactNode } from 'react';

import { CurrentTime, ProgressBar } from './DrivingTimesCell';

export interface RestingTimesCellProps {
    restingMinutes?: number;
    testIdPrefix: string;
    headerMessageId: string;
    children?: ReactNode;
    textColor: string;
}

export const RestingTimesCell = (props: RestingTimesCellProps): JSX.Element => {
    const { restingMinutes, testIdPrefix, headerMessageId, children, textColor } = props;

    return (
        <>
            <CurrentTime
                headerMessageId={headerMessageId}
                testIdPrefix={testIdPrefix}
                currentMinutes={restingMinutes}
                children={children}
                color={textColor}
            />
            <ProgressBar
                testIdPrefix={testIdPrefix}
                progressPercent={0}
                remainingPercent={100}
                extensionPercent={100}
                color={'progress-bar-dark'}
            />
        </>
    );
};
